import * as React from "react"
import {ListItemButton, ListItemIcon, ListItemText, useTheme} from "@mui/material";
import {IconSeeker} from "@components/ui"

import {useActiveLink} from "../../../../../../@hooks";
import {MaximalLayoutNavVerticalIconStyles, MaximalLayoutNavVerticalItemStyles} from "./styles";


export default function MaximalLayoutNavVerticalItem({ path, title, icon, onClick, hasChildren=false, isOpen=false, isSubItem=false, active: activeProp, sx={} }) {
    const theme = useTheme()
    const { active: linkActive } = useActiveLink(path, hasChildren)
    // Group rows have no `path`; their active state is supplied by the NavList
    // (true when any child route matches the current location).
    const active = activeProp ?? linkActive

    const sxItem = MaximalLayoutNavVerticalItemStyles(active, isSubItem, theme)
    return <ListItemButton sx={{ ...sxItem, ...sx.list }} onClick={onClick}>
        <ListItemIcon sx={{ ...MaximalLayoutNavVerticalIconStyles, ...sx.icon }}>
             <IconSeeker  icon={icon} />
        </ListItemIcon>
        <ListItemText primary={title} primaryTypographyProps={{ noWrap: true, component: 'span', variant: active ? 'subtitle2' : 'body2' }} />

        { hasChildren && <IconSeeker icon={ isOpen ? "chevron-down" : "chevron-right" } /> }
    </ListItemButton>
}